import React, { useState, useContext, useEffect } from "react";
import { useCallback } from "react";

const url = "https://www.thecocktaildb.com/api/json/v1/1/search.php?s=";

const AppContext = React.createContext({
  cocktaildatalist: undefined,
  getcocktails: () => {},
  getSinglecocktail: () => {},
  getFilteredcocktailList: () => {},
});

const AppProvider = ({ children }) => {
  const [cocktaildatalist, setcocktaildatalist] = useState();
  const [cocktaildata, setcocktaildata] = useState();

  const getcocktails = useCallback(async () => {
    await fetch(url)
      .then((tempdata) => {
        tempdata = tempdata.json();
        return tempdata;
      })
      .then((Jsondata) => {
        setcocktaildatalist(Jsondata);
        setcocktaildata(Jsondata);
        return Jsondata;
      });

    // let Jsondata = await Rawdata.json();
    // setcocktaildatalist(Jsondata);
    // return Jsondata;
  });
  useEffect(() => {
    getcocktails();
  }, []);

  const getSinglecocktail = (id) => {
    let Singlecocktaildata = undefined;
    if (cocktaildatalist === undefined) {
      Singlecocktaildata = getcocktails();
    } else {
      Singlecocktaildata = cocktaildatalist.drinks.filter(
        (data) => data.idDrink === id
      );
    }
    return Singlecocktaildata;
  };

  const getFilteredcocktailList = (UserInputcocktail) => {
    console.log(cocktaildatalist);
    console.log(UserInputcocktail);

    let FilteredCocktails = cocktaildata.drinks.filter(
      (UserInputcocktaildata) =>
        UserInputcocktaildata.strDrink
          .toLowerCase()
          .includes(UserInputcocktail.toLowerCase())
    );
    FilteredCocktails = { drinks: FilteredCocktails };
    setcocktaildatalist(FilteredCocktails);
    return FilteredCocktails;
  };

  return (
    <AppContext.Provider
      value={{
        cocktaildatalist,
        getSinglecocktail,
        getFilteredcocktailList,
        getcocktails,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
